<div class="header">
    <div class="header-logo">
        <div class="header-logo-opcoep">
            @if (themeMode === 'dark') {
            <img src="assets/img/logo_opco_ep_blanc.png" alt="Logo OPCO EP" />
            } @else {
            <img src="assets/img/logo_opco_ep.png" alt="Logo OPCO EP" />
            }
        </div>
        <div class="header-logo-msel position-relative">
            <img src="assets/svg/logo-mes-services-en-ligne.svg" alt="Mes services en ligne" />
            <span class="appVersion appVersion__header" [ngClass]="{'appVersion__header--snapshot' : !!isSnapshot}">{{formattedVersion}}</span>
        </div>
    </div>
    <!-- <div class="header-notification">
        <div class="header-notification-icon">
            <span class="material-symbols-outlined">
                notifications
            </span>
        </div>
    </div> -->
    @if(isLoggedIn) {
    <div class="header-right">
        <div class="header-settings">
            <div class="header-settings-icon d-none">
                <span class="material-symbols-rounded">
                    campaign
                </span>
            </div>
            <div class="header-settings-icon">
               <lib-dark-light-theme />
            </div>
        </div>
        <div class="header-entreprise">
            <app-mon-compte></app-mon-compte>
            <div class="material-icons hidden-lg-up" (click)="openMenu()">
                menu
            </div>
        </div>
    </div>
    }
</div>
